export enum TYPES {
  SET_STATES = 'setStates',
}

export default TYPES
